<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Icon from '../../common/components/Icon.svelte';

  export let wishlisted = false;

  const dispatch = createEventDispatcher();

  function toggleWishlist() {
    wishlisted = !wishlisted;
    dispatch('changeWishList', { wishlisted });
  }
  $: wishListIcon = wishlisted === true ? 'heart_filled' : 'heart';
  $: StyleClass = wishlisted === true ? 'span__in' : 'span__out';
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="add-wishlist js-pdp-add-wishlist mdc-typography--body2 {wishlisted ? 'active' : ''}"
  on:click={toggleWishlist}
>
  <span class="fav-wrapper {StyleClass} fav_icon">
    <Icon glyph={wishListIcon} mobileSize={16} desktopSize={30} type="font" />
  </span>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .add-wishlist {
    :global(.c_icon_new--heart) {
      color: $primary-blue;
    }
  }
</style>
